module.exports = __webpack_public_path__ + "static/media/zuppler-chef-badge.4b304941.svg";